

import Icon from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const ShieldSVG = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18.199 2.96186L12.4562 1.04697C12.2682 0.984343 12.0649 0.984343 11.8769 1.04697L6.13312 2.96186C5.22022 3.26532 4.42615 3.84872 3.86371 4.62919C3.30127 5.40967 2.99905 6.34752 3 7.30954V12.0001C3 18.9327 11.4332 22.7616 11.7944 22.9211C11.9115 22.9731 12.0383 23 12.1665 23C12.2947 23 12.4215 22.9731 12.5387 22.9211C12.8999 22.7616 21.3331 18.9327 21.3331 12.0001V7.30954C21.3339 6.34741 21.0316 5.40947 20.469 4.62898C19.9064 3.8485 19.1121 3.26516 18.199 2.96186Z" fill="current" stroke="current"/>
</svg>);

export const ShieldIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ShieldSVG} {...props} />
);
